import React, { useContext, useState, useEffect, useRef } from "react";
import { Row, Col, Tooltip, Tabs, Button, Space, Table, Input, Popconfirm, Form, Select, message, DatePicker, Card, Popover } from "antd";
import { FormInstance } from 'antd/lib/form';
import BackNavigation from "../../../utils/Components/BackNavigation";
import "./controllers.css";
import history from '../../../utils/history';
import { connect } from "react-redux";
import * as actions from "./actions";
import { InfoOutlined, PlusOutlined } from "@ant-design/icons";
import moment from 'moment';
import ControllerMaint from "./DeviceMaint";
import { appConfigs } from "../../../utils/configurations";

const { Search } = Input;


interface Props{
    controllersSetSearch: Function,
    controllerSetPagination: Function,
    getControllers: Function,
    openDrawer: Function,
    getAllControllersList: Function,
    setTab: Function,
    context: any,
    controllers: any,
    permissions: any,
    controllersModification: any
}

const Controllers: React.FC<Props> = (props) => {

    const drawerWidth: number = Math.min(window.innerWidth, appConfigs.settings.drawers.defaultWidth);
    const [selectedFilters, setSelectedFilters] = useState<any>({});

    const onTabChange = (key:string) => {
        props.setTab(key)
    }

    const { tableConfig, tableData } = props.controllers.controllersList;

    useEffect(() => {
        props.getAllControllersList()
        props.controllerSetPagination(onPaginationChange(1));
    }, [])

    const renderControllersTable = (pagination: any, filters: any, sorter: any, extra: any, e:any) => {
        setSelectedFilters(filters)
        props.getControllers(null, null, null, pagination.current, props.controllers.controllersList.searchText, filters)
    }

    const onSearch = (searchText: string) => {   
        props.controllersSetSearch((searchText || ""));

        if((searchText || "")==="") {
            history.push("/admin/controllers");
        }
        
        setTimeout(function() {
            props.getControllers(null, null, null, 1, searchText, selectedFilters);   
        }, 100);      
    }

    const onSearchChange = (e: any) => {
        let value = e.target.value;
        props.controllersSetSearch((value || ""));
    }

    const onPaginationChange = (page: number) => {
        props.getControllers(null, null, null, page, props.controllers.controllersList.searchText, selectedFilters);
    };

    const tableColumns = [
        {
            title: 'Device Name',
            dataIndex: 'name',
        },
        {
            title: 'Make',
            dataIndex: 'make',
        },
        {
            title: "Model",
            dataIndex: "model",
        },
        {
            title: "Description",
            dataIndex: "description",
        },
        {
            title: "Technical Specs",
            dataIndex: "technicalSpecs",
        },
        // {
        //     title: "Apps Count",
        //     dataIndex: "appsCount",
        // },
        // {
        //     title: "Assets Count",
        //     dataIndex: "assetsCount",
        // },
        // {
        //     title: "Tags",
        //     dataIndex: "tags",
        // },
        {
            title: "Status",
            dataIndex: "status",
            filterMultiple: true,
            filteredValue: selectedFilters.hasOwnProperty('status') ? selectedFilters.status : [],
            filters: props.controllers.controllersList.columnsFilters.status?.map((status: any) => {
                return { 'value': status, 'text': status }
            }),
        },
        {
            title: "Actions",
            align: "center" as "center",
            render: (text: string, record: any) => (
                <Space>
                    {
                        <Tooltip title="View Controller">
                            <Button
                                type="default" 
                                icon={<InfoOutlined />}
                                onClick={(e) => { props.openDrawer(record.name, drawerWidth, record); }}
                            />
                        </Tooltip>
                    }                        
                </Space>
            )
        }
    ]


    return (

        <div className="layout-content">
            <Row gutter={8}>
                
                <Col xs={24} lg={14}>
                    <div className="content-header page-title">
                        <div style={{ display: "flex" }}>
                            <Tooltip title="Go To Previous Page"> 
                                <BackNavigation /> 
                            </Tooltip>                            
                            {
                                <span>Add Device</span>
                            }
                        </div>
                    </div>
                </Col>

            </Row>
            
            <div className="mt-15">
                <Row justify="end" gutter={24}>
                    
                    <Col xs={24} lg={24} className="content-header-controls">
                        <Space>
                            <Search
                                data-id="controller-search-field"
                                key="search-field"
                                placeholder="Search By Name, Make, Model, Tags"
                                enterButton="Search"
                                size="middle"
                                allowClear
                                onSearch={onSearch}
                                onChange={onSearchChange}
                                className="search-field"
                                value={props.controllers.controllersList.searchText}
                            />

                            <Button data-id="assets-search-new-button" type="primary" icon={<PlusOutlined />} onClick={(e) =>  props.openDrawer("New Device", drawerWidth, {})}>
                                <span>Device</span>
                            </Button>
                        </Space>
                    </Col>

                    
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Table 
                            data-id="controllers-data" 
                            className="mt-15"
                            style={{ overflowX: 'auto' }} 
                            {...tableConfig}
                            rowKey={(record) => record.make+'-'+record.model+'-'+record.partNumber}
                            columns={tableColumns}
                            dataSource={tableData}
                            onChange={renderControllersTable}
                            showSorterTooltip={false}
                        />
                    </Col>       
                </Row>
                    
            </div>

            <ControllerMaint/>
        </div>

    );

}

const mapStateToProps = (state:any) => {
    return {
        permissions: state.contextReducer.data,
        context: state.contextReducer.context,
        controllers: state.controllersReducers.controllersState.controllers,
        controllersModification: state.controllersReducers.controllersState.controllers.controllersModification,
    };
};

export default connect(
    mapStateToProps,
    actions
)(Controllers);
